<template>
    <div class="tab-container">
        <div class="tab-button-content">
            <div class="icon-button" :class="getIconClass">
                <i :class="getIcon" v-if="getIcon"></i>
            </div>
            <input class="input-button"
                   type="button"
                   :value="getText"/>
        </div>
        <span class="bar" :class="getBarClass"></span>
    </div>
</template>

<script>
    export default {
        name: "TabButton",
        props: {
            text: String,
            icon: String,
            isFocused: Boolean
        },
        data() {
            return {
                focused: this.isFocused
            }
        },
        computed: {
            getText() {
                return this.text;
            },
            getIcon() {
                return this.icon;
            },
            getIconClass() {
                return this.focused ? 'icon-focused' : '';
            },
            getBarClass() {
                return this.focused ? 'bar-focused' : '';
            }
        },
        watch: {
            isFocused(newVal) {
                this.focused = newVal;
            }
        }
    }
</script>

<style scoped>
    .tab-container {
        width: fit-content;
        text-align: center;
        height: fit-content;
        color: var(--dark-grey);
    }

    .tab-button-content {
        margin: auto;
        width: fit-content;
    }

    .tab-container:hover {
        color: var(--primary-blue);
        cursor: pointer;
    }

    .input-button {
        float: left;
        width: fit-content;
        border: none;
        cursor: inherit;
        background-color: transparent;
        padding: 10px;
        color: inherit;
    }

    input:focus {
        outline-color: transparent;
        outline-style: none;
        border-color: transparent;
    }

    input[type='button'] {
        font-size: 23px;
        font-family: Arial, Helvetica, sans-serif;
    }

    .bar {
        position: relative;
        float: left;
        display: block;
        width: 100%;
    }

    .bar:before, .bar:after {
        content: '';
        height: 3px;
        width: 0;
        bottom: 0;
        position: absolute;
        background: var(--primary-blue);
        transition: 0.3s ease all;
        -moz-transition: 0.3s ease all;
        -webkit-transition: 0.3s ease all;
    }

    .bar:before {
        left: 50%;
    }

    .bar:after {
        right: 50%;
    }

    .icon-button {
        float: left;
        font-size: 27px;
        margin-top: 8px;
        margin-right: 2px;
        margin-left: 10px;
        color: inherit;
    }

    .bar-focused:before, .bar-focused:after {
        width: 50%;
    }

    .icon-focused {
        color: var(--primary-blue);
    }
</style>